












































































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import Warning from '@/components/page/Warning.vue';
import PageScope from '@/components/common/PageScope.vue';
import { ViewObject } from '@/api/com/MetaPattern/MDA/MD/UIModel/ViewObject';
import { BEAttribute } from '@/api/com/MetaPattern/MDA/MD/EntityModel/BEAttribute';
import { EVOAttribute } from '@/api/com/MetaPattern/MDA/MD/UIModel/EVOAttribute';
import { EVOAction } from '@/api/com/MetaPattern/MDA/MD/UIModel/EVOAction';
import { EnumPersistenceStatus } from '@/api/com/MetaPattern/Core/Infrastructure/Common/EnumPersistenceStatus';
import { UIModelComponent } from '@/api/com/MetaPattern/MDA/MD/UIModel/UIModelComponent';
import { EnumDataType, EnumDataTypeMD } from '@/api/com/MetaPattern/Core/Infrastructure/Common/EnumDataType';
import { ElTable } from 'element-ui/types/table';
import { EnumAlignStyle } from '@/api/com/MetaPattern/MDA/MD/UIModel/EnumAlignStyle';
import { MDRepository } from '@/libs/com/MetaPattern/MDA/MD/MDRepository';
import { EntityAttributesDTO } from '@/api/com/MetaPattern/MDA/MD/EntityModel/EntityAttributesDTO';
import { MDService } from '@/api/com/MetaPattern/MDA/MD/EntityModel/MDService';
import { IDEProgram } from '@/libs/com/MetaPattern/Product/IDE/IDEProgram';
import { ActionType } from '@/api/com/MetaPattern/MDA/MD/UIModel/ActionType';
import { MDExtendService } from '@/libs/com/MetaPattern/MDA/MD/MDExtendService';
import CacheItem from '@/libs/com/MetaPattern/Product/IDE/Util/CacheItem';
import { ValidateHelper } from '@/libs/com/MetaPattern/Product/IDE/Util/ValidateHelper';

@Component({
  components: {
    Warning,
    PageScope
  }
})
export default class ViewObjectEditor extends Vue {
  @Prop() viewObject!: ViewObject; // 选中的视图对象
  @Prop() curComponent: UIModelComponent; // 当前操作的UI模型对组件
  private entityAttributeOptions: Array<BEAttribute>; // 供选择的实体属性集合
  private actionTypeOptions: Array<ActionType>; // 供选择的实体操作集合
  private selectedBEAttributeId: string; // 选中的属性ID
  private selectedActionId: string; // 选中的操作ID

  constructor() {
    super();
    this.selectedBEAttributeId = '';
    this.selectedActionId = '';
    this.entityAttributeOptions = null;
    this.actionTypeOptions = null;
  }

  mounted() {
    const result = this.$store.getters['ObjectCache/cacheItem'](this.viewObject.bindingBEEntity_ID + 'AllAttributes');
    if (!ValidateHelper.IsNotNullOrUndefined(result)) {
      MDService.GetAllAttributesAsync(this.viewObject.bindingBEEntity_ID)
        .then((dto: EntityAttributesDTO) => {
          this.entityAttributeOptions = dto.attributes;
          const cacheItem = new CacheItem(this.viewObject.bindingBEEntity_ID + 'AllAttributes', this.entityAttributeOptions, 60);
          this.$store.dispatch('ObjectCache/addItemAction', cacheItem);
        });
    } else {
      this.entityAttributeOptions = result as Array<BEAttribute>;
    }
    this.actionTypeOptions = new Array<ActionType>();
    IDEProgram.instance.getActionTypes().forEach(item => {
      this.actionTypeOptions.push(item);
      // const find = this.viewObject.actions.find(action => action.actionType_ID === item.id);
      // if (!find) {
      //   this.actionTypeOptions.push(item);
      // }
    });
  }

  get loadingViewObject() {
    return this.entityAttributeOptions === null;
  }

  /** 选中属性表格行的事件处理 */
  selectAttributeRow(currentRow: EVOAttribute, oldRow: any) {
    if (currentRow) {
      this.clearActionTableSelected();
      this.$store.dispatch('ModuleMD/setCurMDDesignIdAction', currentRow.designId);
      this.$store.dispatch('ModuleMD/setCurMDElementAction', { element: currentRow });
    }
  }

  /** 选中操作表格行的事件处理 */
  selectActionRow(currentRow: EVOAction, oldRow: any) {
    if (currentRow) {
      this.clearAttributeTableSelected();
      this.$store.dispatch('ModuleMD/setCurMDDesignIdAction', currentRow.designId);
      this.$store.dispatch('ModuleMD/setCurMDElementAction', { element: currentRow });
    }
  }

  /** 删除一行 */
  deleteRow(row: EVOAction | EVOAttribute, e: any) {
    const message = '是否确定要删除：' + row.displayName;
    this.$confirm(message, '删除提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning'
    }).then(() => {
      let success = false;
      if (row instanceof EVOAttribute) {
        if (row.bindingBEAttribute.isTitle) {
          this.$message({ type: 'error', message: '标题属性不能移除!' });
        } else {
          row.removed = true;
          row.modify();
          MDExtendService.setElementListSequence(this.viewObject.attributes, true);
          this.$message({ type: 'info', message: '成功删除属性!' });
          success = true;
        }
      } else if (row instanceof EVOAction) {
        row.removed = true;
        row.modify();
        // 将Action对应的Button全部设为无效
        this.curComponent.buttons.forEach(button => {
          if (button.action_ID === row.id) {
            button.removed = true;
            button.modify();
          }
        });
        this.$message({ type: 'info', message: '成功删除操作!' });
        success = true;
      }
      if (success) {
        this.curComponent.modify();
      }
    });
    e.stopPropagation();
  }

  /** 上移 */
  upRow(row: EVOAttribute, e: any) {
    const curIndex = this.viewObject.attributes.findIndex(item => item.id === row.id);
    if (curIndex > 0) {
      const curAttributes = this.viewObject.attributes.splice(curIndex, 1);
      this.viewObject.attributes.splice(curIndex - 1, 0, ...curAttributes);
      MDExtendService.setElementListSequence(this.viewObject.attributes, true);
      this.curComponent.modify();
    }
  }

  /** 下移 */
  downRow(row: EVOAttribute, e: any) {
    const curIndex = this.viewObject.attributes.findIndex(item => item.id === row.id);
    if (curIndex < this.viewObject.attributes.length) {
      const curAttributes = this.viewObject.attributes.splice(curIndex, 1);
      this.viewObject.attributes.splice(curIndex + 1, 0, ...curAttributes);
      MDExtendService.setElementListSequence(this.viewObject.attributes, true);
      this.curComponent.modify();
    }
  }

  get attributesData() {
    if (this.viewObject !== null) {
      return this.viewObject.attributes.filter(item => item.persistenceStatus !== EnumPersistenceStatus.Delete && !item.removed);
    }
    return null;
  }

  /** 获取属性在列表中的顺序，是否首行 */
  isFirstAttribute (attributeId: string) {
    return this.attributesData.findIndex(item => item.id === attributeId) === 0;
  }

  /** 获取属性在列表中的顺序，是否首行 */
  isLastAttribute (attributeId: string) {
    return this.attributesData.findIndex(item => item.id === attributeId) === this.attributesData.length - 1;
  }

  get actionsData() {
    if (this.viewObject !== null) {
      return this.viewObject.actions.filter(item => item.persistenceStatus !== EnumPersistenceStatus.Delete && !item.removed);
    }
    return null;
  }

  getBooleanStyle(value: boolean) {
    if (value) {
      return 'el-icon-check boolYes';
    }
    return 'el-icon-close boolNo';
  }

  getDataType(attribute: EVOAttribute) {
    let dataType = '';
    if (attribute.bindingBEAttribute !== null) {
      if (attribute.bindingBEAttribute.dataType === EnumDataType.Reference || attribute.bindingBEAttribute.dataType === EnumDataType.UniqueKey) {
        dataType = attribute.bindingBEAttribute.referenceType;
      } else {
        dataType = EnumDataTypeMD.getItemByValue(attribute.bindingBEAttribute.dataType).name;
      }
    }
    return dataType;
  }

  getActionType(action: EVOAction) {
    if (action.actionType != null) {
      return `${action.actionType.displayName}(${action.actionType.name})`;
    }
    return '';
  }

  clearAttributeTableSelected() {
    (this.$refs.attributeTable as ElTable).setCurrentRow(null);
  }

  clearActionTableSelected() {
    (this.$refs.actionTable as ElTable).setCurrentRow(null);
  }

  getAttributeOptions() {
    const attributes = new Array<BEAttribute>();
    if (this.entityAttributeOptions && this.entityAttributeOptions !== null) {
      this.entityAttributeOptions.forEach(attribute => {
        if (attribute.isForFront && !this.viewObject.attributes.find(attr => attr.bindingBEAttribute_ID === attribute.id && attr.persistenceStatus !== EnumPersistenceStatus.Delete && !attr.removed)) {
          attributes.push(attribute);
        }
      });
    }
    return attributes;
  }

  getActionOptions() {
    const actions = new Array<ActionType>();
    if (this.actionTypeOptions && this.actionTypeOptions !== null) {
      this.actionTypeOptions.forEach(actionType => {
        // TODO : 需要支持自定义操作
        if (actionType.code !== 'Custom' && !this.viewObject.actions.find(action => action.actionType_ID === actionType.id && action.persistenceStatus !== EnumPersistenceStatus.Delete && !action.removed)) {
          actions.push(actionType);
        }
      });
    }
    return actions;
  }

  @Watch('selectedBEAttributeId')
  handleAddEntityAttribute() {
    if (this.selectedBEAttributeId !== '') {
      let find = this.viewObject.attributes.find(item => item.bindingBEAttribute_ID === this.selectedBEAttributeId);
      if (!find) {
        const beAttribute = this.entityAttributeOptions.find(item => item.id === this.selectedBEAttributeId);
        find = MDRepository.createEVOAttribute(null); // 这里不传入视图对象，要将属性都设置完成以后才能传入，否则设置的值在页面上不会自动更新
        find.name = beAttribute.name;
        find.displayName = beAttribute.displayName;
        find.description = beAttribute.description;
        find.bindingBEAttribute = beAttribute;
        find.isSync = true;
        find.isSearch = true;
        find.sequence = this.viewObject.attributes.length + 1;
        if (beAttribute.dataType === EnumDataType.Text || beAttribute.dataType === EnumDataType.Richtext || beAttribute.dataType === EnumDataType.Guid) {
          find.isSearch = false;
        }
        switch (beAttribute.dataType) {
          case EnumDataType.Bool:
          case EnumDataType.Date:
          case EnumDataType.DateTime:
          case EnumDataType.Time:
            find.alignStyle = EnumAlignStyle.Center;
            find.isSortable = true;
            break;
          case EnumDataType.Double:
          case EnumDataType.Float:
          case EnumDataType.Int:
          case EnumDataType.Long:
          case EnumDataType.Money:
          case EnumDataType.Short:
            find.alignStyle = EnumAlignStyle.Right;
            find.isSortable = true;
            break;
          case EnumDataType.Guid:
          case EnumDataType.Richtext:
          case EnumDataType.String:
          case EnumDataType.Text:
          case EnumDataType.UniqueKey:
          case EnumDataType.Reference:
            find.alignStyle = EnumAlignStyle.Left;
            find.isSortable = false;
            break;
          default:
            find.alignStyle = EnumAlignStyle.Left;
            find.isSortable = false;
            break;
        }
        find.viewObject = this.viewObject;
        this.viewObject.attributes.push(find);
      } else if (find.removed) {
        find.removed = false; // 将移除的操作
      }
      find.modify(true);
      this.curComponent.modify();
      this.selectedBEAttributeId = '';
    }
  }

  @Watch('selectedActionId')
  handleAddAction() {
    if (this.selectedActionId !== '') {
      const actionType = IDEProgram.instance.getActionTypes().find(item => item.id === this.selectedActionId);
      if (actionType) {
        let find = this.viewObject.actions.find(item => item.actionType_ID === this.selectedActionId);
        if (!find) {
          find = MDRepository.createEVOAction(null, actionType);
          find.description = actionType.description;
          find.sequence = this.viewObject.actions.length + 1;
          find.viewObject = this.viewObject;
          this.viewObject.actions.push(find);
        } else if (find.removed) {
          find.removed = false; // 将移除的操作
        }
        find.modify(true);
        this.curComponent.modify();
        // 将Action对应的Button全部设为有效
        this.curComponent.buttons.forEach(button => {
          if (button.action_ID === find.id) {
            button.isValid = true;
            button.modify();
          }
        });
      }
      this.selectedActionId = '';
    }
  }
}
